import { render, staticRenderFns } from "./OverallTotals.vue?vue&type=template&id=ebbc37a6&"
import script from "./OverallTotals.vue?vue&type=script&lang=js&"
export * from "./OverallTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports